module.exports = __webpack_public_path__ + "img/home5.b3552541.png";